export default __webpack_public_path__ + "static/media/st.893763a9.svg";